import { HttpErrorCode } from './types';

export class UploadError extends Error {
  code: HttpErrorCode;
  constructor(message: string, code: number) {
    super(message);
    switch (code) {
      case 400:
        this.code = HttpErrorCode.BadRequest;
        break;
      case 401:
        this.code = HttpErrorCode.Unauthorized;
        break;
      case 402:
        this.code = HttpErrorCode.PaymentRequired;
        break;
      case 403:
        this.code = HttpErrorCode.Forbidden;
        break;
      case 404:
        this.code = HttpErrorCode.NotFound;
        break;
      case 413:
        this.code = HttpErrorCode.ContentTooLarge;
        break;
      default:
        this.code = HttpErrorCode.UnknownError;
    }
  }
}
